import { UpdatePaymentFrequency } from "./UpdatePaymentFrequency";

export default UpdatePaymentFrequency;
